export const SUGGESTED_TAGS = [
  "Travel",
  "Holiday",
  "Food",
  "Tech",
  "Fitness",
  "Photography",
  "Music",
  "Art",
  "Nature",
  "Sports",
  "Health",
  "Education",
  "Business",
  "Fashion",
  "Movies",
] as const;

export const MAX_SUGGESTIONS = 5;